export enum PosologyTypeEnum {
  FREE_TEXT,
  SIMPLE,
  REPEAT,
  PHASING,
  WEEKDAY,
  DATE,
}

export const translateKey = (value: string): string => {
  return "posologyType." + value.toLowerCase();
};

export const supportedPosologyType = () => {
  return [PosologyTypeEnum.FREE_TEXT, PosologyTypeEnum.SIMPLE];
};

export const allPosologyType = () => {
  return [
    PosologyTypeEnum.FREE_TEXT,
    PosologyTypeEnum.SIMPLE,
    PosologyTypeEnum.REPEAT,
    PosologyTypeEnum.PHASING,
    PosologyTypeEnum.WEEKDAY,
    PosologyTypeEnum.DATE,
  ];
};
